@let announcements = announcementsToDisplay$ | async;
<medpace-page>
    <div class="flex flex-col gap-medpace">
        <h1>Dashboard</h1>

        <medpace-request-dashboard-card2 [requestsCount]="requestsCount$ | async"></medpace-request-dashboard-card2>

        <medpace-active-studies-table />

        @if (hasPermissionToPendingStudies$ | async) {
            <mds-expansion-panel
                [panelTitle]="'Pending Approval Studies'"
                [description]="''"
                icon="access_time"
                [attr.data-cy]="'pendingApprovalStudies'"
                #pendingStudiesPanel
            >
                @defer (on interaction(pendingStudiesPanel)) {
                    <medpace-table
                        (rowClickEvent)="goToEditStudy($event)"
                        [columns]="pendingStudiesColumns"
                        [data]="(activeClinTrakStudies$ | async) || undefined"
                        [fieldMap]="pendingStudiesColumnMap"
                        [ifFiltering]="false"
                        [isSearching]="true"
                        [title]=""
                        [isCard]="false"
                    ></medpace-table>
                } @placeholder {
                    <medpace-loading />
                }
            </mds-expansion-panel>
        }
    </div>
</medpace-page>
